module.exports = __webpack_public_path__ + "static/media/icons_Bilan Poignet.25b69766.svg";